import React from 'react'
import './Game.css'
import Board from './Board/Board';

const MAX_WIDTH = 400;
const MIN_WIDTH = 300;

const initBoardValues = (size) => {
    return shuffle([...Array(size * size + 1).keys()].slice(1));
}

const shuffle = (a) => {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}




class Game extends React.Component {

    state = {
        next: 1,
        time: 0,
        boardValues: initBoardValues(this.props.size),
        timeRunning: false,
        done: false,
    };

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (prevProps.size !== this.props.size) {
            clearInterval(this.timer);
            this.setState(this.loadDefaultState());
        }
    }

    handleCellClick = (value) => {
        if (value === this.props.size * this.props.size && this.state.next === this.props.size * this.props.size) {
            //win
            clearInterval(this.timer);
            this.setState({ done: true, timeRunning: false })
            let gamesPlayed = parseInt(localStorage.getItem("gamesPlayed" + this.props.size));
            if (!gamesPlayed) gamesPlayed = 0;
            localStorage.setItem("gamesPlayed" + this.props.size, ++gamesPlayed);

            let bestTime = parseInt(localStorage.getItem("bestTime" + this.props.size));
            if (!bestTime || bestTime > this.state.time) bestTime = this.state.time;
            localStorage.setItem("bestTime" + this.props.size, bestTime);

            this.props.onGameDone();
        }
        else if (value === this.state.next) {
            this.setState({ next: value + 1 });
        }

        if (!this.state.timeRunning) {
            this.setState({ timeRunning: true })
            this.timer = setInterval(() => {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        time: prevState.time + 1
                    }
                })
            }, 10);
        }
    }

    handleRestart = () => {
        clearInterval(this.timer);
        this.setState(this.loadDefaultState());
    }

    loadDefaultState = () => {
        return (
            {
                next: 1,
                time: 0,
                boardValues: initBoardValues(this.props.size),
                timeRunning: false,
                done: false,
            }
        )

    }


    render() {
        let gameWidth = this.props.width - 200 - 64;
        if (gameWidth < MIN_WIDTH) gameWidth = MIN_WIDTH;
        else if (gameWidth > MAX_WIDTH) gameWidth = MAX_WIDTH;

        return (
            <div className="game-container">
                <div className="top-bar" style={{ width: gameWidth }} size={this.props.size}>
                    <p>Next: <span style={{ color: "black" }}>{this.state.next}</span></p>
                    <p>{(this.state.time / 100).toFixed(2)}</p>
                </div>
                <Board boardValues={this.state.boardValues}
                    gameWidth={gameWidth}
                    size={this.props.size}
                    clicked={this.handleCellClick}
                    done={this.state.done} />
                <p className="desc">Click on numbers from 1 to {this.props.size * this.props.size} in ascending order</p>
                <button className="restart-button" onClick={this.handleRestart}>Restart</button>
            </div>
        )
    }


}

export default Game
